import { tr as __tr, useLocale as __useLocale } from "../i18n/runtime";
import React from 'react';
import CatalogResults from './CatalogResults';
export default function PopularDestinations() {
  __useLocale();
  return <CatalogResults kind="hotel" />;
}
